import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { db, storage } from "../../../firebaseConfig";
import { collection, doc, setDoc } from "firebase/firestore";
import LoadingButton from "../../Commons/loadingButton";
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { nanoid } from "nanoid";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';


const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [missingInput, setMissingInput] = useState(false);
  const [personalInfo, setPersonalInfo] = useState({
    phone: "",
    email: "",
    name: "",
    business: "",
    address: "",
    businessAcc: "",
    upiNum: "",
  });
  const [companyInfo, setCompanyInfo] = useState({
    profilePic: null,
    businessDocs: null,
    aadharCard: null,
    gst: null,
  });
  const [others, setOthers] = useState({
    agree: false,
  });
  
  const [errors, setErrors] = useState({
    phone: "",
    email: "",
  });

  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone);
  };

  const handleFileUpload = async (file, fileName) => {
    const fileRef = ref(storage, `userDocs/${personalInfo.phone}/${fileName}`);
    // ->  userDocs/phone/fileName
    await uploadBytes(fileRef, file);
    return await getDownloadURL(fileRef);
  };

  const handleNext = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSubmit = async () => {

    // if (!personalInfo.name || !personalInfo.phone || !personalInfo.businessAcc || !personalInfo.address || !personalInfo.email || others.agree) {
    //   setMissingInput(true);
    //   return;
    // }

    setLoading(true);

    const uploadPromises = [
      companyInfo.profilePic ? handleFileUpload(companyInfo.profilePic, "profilePic") : null,
      companyInfo.businessDocs ? handleFileUpload(companyInfo.businessDocs, "businessDocs") : null,
      companyInfo.gst ? handleFileUpload(companyInfo.gst, "gst") : null,
    ];


    const [profilePicUrl, businessDocsUrl, gstUrl] = await Promise.all(uploadPromises) || null;


    const formData = {
      ...personalInfo,
      Kyc: {
        profilePic: profilePicUrl,
        businessDocs: businessDocsUrl,
        gst: gstUrl,
      },
      others,
      "phone": `+91${personalInfo.phone}`,
      "createdAt": Date.now(),
      userId: `U-${nanoid()}`
    };

    let docRef = doc(db, "userDetails", `+91${personalInfo.phone}`)
    await setDoc(docRef, formData);

    let cartDocRef = doc(db, "cart", `+91${personalInfo.phone}`);
    await setDoc(cartDocRef, { cart: [] });

    let orderHistoryDocRef = doc(db, "orderHistory", `+91${personalInfo.phone}`);
    await setDoc(orderHistoryDocRef, { order: [] });

    let profileProdDocRef = doc(db, "profileProduct", `+91${personalInfo.phone}`);
    await setDoc(profileProdDocRef, { product: [] });
    setTimeout(() => {
      setLoading(false);
      navigate("/login");
    }, 1000);
    // alert("Form submitted successfully!");
  };

  return (
    <Container maxWidth="sm">
      <CssBaseline />
      <Box>

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="90vh"
          paddingX={3}
          borderRadius={2}
          boxShadow={3}
          bgcolor="#f9f9f9"
          marginTop={3}
        >

          <Typography variant="h4" sx={{ fontWeight: 600, marginBottom: "20px", textAlign: "center" }} >Sign Up</Typography>
          {currentStep === 1 && (
            <Box width="100%">
              <Typography variant="h5" align="center" gutterBottom>
                Personal Info
              </Typography>
              <TextField
                label="Name"
                fullWidth
                margin="normal"
                value={personalInfo.name}
                onChange={(e) => setPersonalInfo({ ...personalInfo, name: e.target.value })}
                required
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                  justifyContent: "center",
                  padding: 2,
                }}
              >
                <Typography textAlign="left" >
                  Business Account
                </Typography>
                <FormControlLabel
                  control={
                    <RadioGroup
                      sx={{ display: "flex", marginLeft: "10px" }}
                      value={personalInfo.businessAcc}
                      onChange={(e) => setPersonalInfo({ ...personalInfo, businessAcc: e.target.value })}
                    >
                      <FormControlLabel value="true" control={<Radio />} label="YES" />
                      <FormControlLabel value="false" control={<Radio />} label="NO" />
                    </RadioGroup>
                  }
                />
              </Box>
              <TextField
                label="Phone"
                fullWidth
                margin="normal"
                value={personalInfo.phone}
                onChange={(e) => {
                  const phone = e.target.value;
                  setPersonalInfo({ ...personalInfo, phone });
                  if (!validatePhone(phone)) {
                    setErrors({ ...errors, phone: "Invalid phone number (10 digits required)" });
                  } else {
                    setErrors({ ...errors, phone: "" });
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+91</InputAdornment>
                  ),
                }}
                error={!!errors.phone}
                helperText={errors.phone}
                required
              />
              <TextField
                label="UPI Number (For Sellers)"
                fullWidth
                margin="normal"
                value={personalInfo.upiNum}
                onChange={(e) => {
                  const upiNum = e.target.value;
                  setPersonalInfo({ ...personalInfo, upiNum });
                  if (!validatePhone(upiNum)) {
                    setErrors({ ...errors, upiNum: "Invalid phone number (10 digits required)" });
                  } else {
                    setErrors({ ...errors, upiNum: "" });
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+91</InputAdornment>
                  ),
                }}
                error={!!errors.upiNum}
                helperText={errors.upiNum}
                required
              />
              <TextField
                label="Email"
                fullWidth
                margin="normal"
                value={personalInfo.email}
                onChange={(e) => {
                  const email = e.target.value;
                  setPersonalInfo({ ...personalInfo, email });
                  if (!validateEmail(email)) {
                    setErrors({ ...errors, email: "Invalid email address" });
                  } else {
                    setErrors({ ...errors, email: "" });
                  }
                }}
                error={!!errors.email}
                helperText={errors.email}
                required
              />
              <TextField
                label="Address"
                fullWidth
                margin="normal"
                value={personalInfo.address}
                onChange={(e) => setPersonalInfo({ ...personalInfo, address: e.target.value })}
                required
              />
            </Box>
          )}
          {currentStep === 2 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "center",
                padding: 3,
              }}
            >
              <Typography variant="h5" align="center" gutterBottom >
                Company Info
              </Typography>

              <Typography sx={{ marginTop: "20px" }}>Add Profile Pic</Typography>
              <Button
                variant="contained"
                component="label"
                sx={{ width: "100%" }}
              >

                <input
                  type="file"
                  onChange={(e) => setCompanyInfo({ ...companyInfo, profilePic: e.target.files[0] })}
                  required
                />
              </Button>

              <Typography sx={{ marginTop: "20px" }}>Attach Business Registration Documents*</Typography>
              <Button
                variant="contained"
                component="label"
                sx={{ width: "100%" }}
              >
                <input
                  type="file"
                  onChange={(e) => setCompanyInfo({ ...companyInfo, businessDocs: e.target.files[0] })}
                  required
                />
              </Button>

              <Typography sx={{ marginTop: "20px" }}>GST</Typography>
              <Button
                variant="contained"
                component="label"
                sx={{ width: "100%" }}
              >
                <input
                  type="file"
                  onChange={(e) => setCompanyInfo({ ...companyInfo, gst: e.target.files[0] })}
                />
              </Button>
            </Box>

          )}

          {/* T&C */}
          {currentStep === 3 && (
            <Box width="100%" >
              <Typography variant="h4" align="center" gutterBottom>
                Policy
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 2,
                }}
              >
                <Typography variant="body1" gutterBottom>
                  Please read and agree to the following terms and conditions:
                </Typography>

                <Typography variant="body2" gutterBottom>
                  1. Sellers are strictly prohibited from engaging in any fraudulent activities, including but not limited to misrepresentation of products, services, or pricing. Any attempts to deceive buyers will result in immediate action.
                </Typography>
                <Typography variant="body2" gutterBottom>
                  2. Sellers must report any suspicious activities or potential fraudulent behavior by buyers to our support team promptly. Failure to do so may result in penalties.
                </Typography>
                <Typography variant="body2" gutterBottom>
                  3. Any allegations of fraud will be thoroughly investigated. If a seller is found to have committed fraud, they will face immediate account suspension or termination, with no possibility of reinstatement.
                </Typography>
                <Typography variant="body2" gutterBottom>
                  4. Sellers will be held liable for any financial losses incurred by buyers as a result of fraudulent actions. Compensation may be required in addition to penalties imposed by our platform.
                </Typography>
                <Typography variant="body2" gutterBottom>
                  5. By continuing to operate on our platform, sellers acknowledge and agree to adhere to this zero tolerance policy. Non-compliance will result in enforcement actions as deemed necessary by our team.
                </Typography>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={others.agree}
                      onChange={(e) => setOthers({ ...others, agree: e.target.checked })}
                    />
                  }
                  label="I Agree"
                />
              </Box>
            </Box>

          )}
          <Box mt={3} display="flex" justifyContent="space-between" width="100%">
            <Button onClick={handleBack} disabled={currentStep === 1}>
              Back
            </Button>
            {currentStep < 3 ? (
              <Button variant="contained" color="primary" onClick={handleNext}>
                Next
              </Button>
            ) : (
              <div>
                <LoadingButton loading={loading} variant="contained" color="primary" onClick={handleSubmit}>
                  SignUp
                </LoadingButton>
                {missingInput &&
                  <Alert severity="error">Fill all the required data.</Alert>
                }
              </div>

            )}
          </Box>
        </Box>
      </Box>
      <Box justifyContent="center" sx={{ mt: 6 }}>
        <Box item>
          <Link
            href="/login"
            variant="body2"
            sx={{
              textAlign: "center",
              color: "#000",
              fontWeight: "bold",
            }}
          >
            {"Already have account?"}
            <>&nbsp;</>{" "}
            <span style={{ fontWeight: "bold" }}>Sign in</span>
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default SignUp;